"use client";

import React from "react";
import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const businessDescription = "The London Blockchain Centre specializes in professional cryptocurrency recovery and advanced blockchain forensics. Our team utilizes proprietary technology to investigate fraud, trace assets, and restore digital access for victims of cybercrime.";
const address = "52 Sparks Street, Ottawa, Canada";
const phone = "+1 343 882 4483";
const email = "contact@thelondonblockchaincentre.com";
const services = ["Wallet Recovery", "Scam & Fraud Investigation", "Blockchain Forensics", "Asset Tracing", "Cybersecurity Audit", "Expert Witness"];
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-primary/20 animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <p className="text-muted-foreground/60 text-sm font-mono">No links available.</p>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="162051" id="footer" className="dark bg-background text-foreground border-t border-primary/30 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604898/img/vardanyan_footer_logo_gold.png" alt="The London Blockchain Centre" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {businessDescription}
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-sans font-bold tracking-tight text-foreground uppercase">
              Quick Links
            </h3>
            <MenuProvider menu_id="41">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-sans font-bold tracking-tight text-foreground uppercase">
              Forensic Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="/ForensicServicesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-sans font-bold tracking-tight text-foreground uppercase">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground text-sm font-mono">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>{address}</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-mono">
                <Phone className="size-5 text-primary shrink-0" />
                <Link href={`tel:${phone.replace(/\s+/g, '')}`} className="hover:text-primary transition-colors">
                  {phone}
                </Link>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground text-sm font-mono">
                <Mail className="size-5 text-primary shrink-0" />
                <Link href={`mailto:${email}`} className="hover:text-primary transition-colors">
                  {email}
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="bg-primary/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground/60 font-mono">
          <p>
            &copy; {currentYear} The London Blockchain Centre. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>

          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="text-muted-foreground/60 hover:text-primary transition-colors">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}